<subscription-output-form [subscription]="subscription()">
</subscription-output-form>

<button mat-raised-button color="warn" class="delete-button" (click)="onDelete()">
    <mat-icon>delete</mat-icon>
    {{'button.delete' | translate}}
</button>    
